import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-ai-ml-use-case',
  templateUrl: './ai-ml-use-case.component.html',
  styleUrls: ['./ai-ml-use-case.component.css']
})
export class AiMlUseCaseComponent implements OnInit {
 
  constructor(private viewportScroller: ViewportScroller,
    private titleService: Title, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,private seoService:SeoService,
    private metaService: Meta
  ) {}
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/ai-ml-use-case/"
  },
  "headline": "AI/ML Use Case: Real-Time Facial Expression Recognition and Annotation",
  "description": "Explore how we built FER with applications in personalized retail recommendations, emotion decoding in entertainment to marketing insights.",
  "image": "https://mitresource.com/assets/images/AI-casestudy-images/banner-image.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-01-15"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  baseUrl=Constants.baseUrl;
imageItems1 = [
{ src: '../../../assets/images/AI-casestudy-images/the-approach-img.png' }
// Add more items as needed
];

imageItems2 = [
{ src: '../../../assets/images/AI-casestudy-images/FER-app-img.png' }
// Add more items as needed
];

enlargedImageSrc: string | null = null;
isEnlargedVisible = false;
currentIndex = 0;
currentImageList: 'imageItems1' | 'imageItems2' = 'imageItems1';

showEnlargedImage(src: string): void {
this.enlargedImageSrc = src;
this.currentIndex = (this[this.currentImageList] as Array<{ src: string }>)
  .findIndex(item => item.src === src);
this.isEnlargedVisible = true;
}

hideEnlargedImage(): void {
this.isEnlargedVisible = false;
}

prevImage(): void {
const currentList = this[this.currentImageList] as Array<{ src: string }>;
if (currentList.length > 0) {
  this.currentIndex = (this.currentIndex - 1 + currentList.length) % currentList.length;
  this.enlargedImageSrc = currentList[this.currentIndex].src;
}
}

nextImage(): void {
const currentList = this[this.currentImageList] as Array<{ src: string }>;
if (currentList.length > 0) {
  this.currentIndex = (this.currentIndex + 1) % currentList.length;
  this.enlargedImageSrc = currentList[this.currentIndex].src;
}
}

setCurrentImageList(list: 'imageItems1' | 'imageItems2'): void {
this.currentImageList = list;
this.enlargedImageSrc = null; // Clear enlarged image when changing lists
this.isEnlargedVisible = false; // Hide enlarged view when changing lists
}


scrollToSection(sectionId: string): void {
  this.viewportScroller.scrollToAnchor(sectionId);
}
private setTitleAndMetaTags(): void {
  this.titleService.setTitle('AI/ML Use Case: Real-Time Facial Expression Recognition and Annotation');

  this.metaService.addTags([
    { name: 'description', content: 'One of the most universal ways that people communicate is through facial expressions!' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: 'AI/ML Use Case: Real-Time Facial Expression Recognition and Annotation' },
    { property: 'og:url', content: 'https://mitresource.com/ai-ml-use-case/' },
    { property: 'og:image', content: 'https://mitresource.com/assets/images/AI-casestudy-images/banner-image.png' },
    { property: 'og:description', content: 'One of the most universal ways that people communicate is through facial expressions.' },
  ]);
}
}
